import {
  selectTitleNode,
  selectTitleWithDescriptionNode,
} from '@newStore/documentUI/transformContent/genericSelectors';
import { validateDownloadListAndFaqPageShouldNotHaveDescription } from '@newStore/validation/validationRules/downloadPageShouldNotHaveDescription';
import {
  type ExtendedBuildingBlockNodeConfig,
  type ExtendedRootNodeConfig,
  NodeType,
} from '@nodeTypeConfig/configTypes';
import { proThemeTocTypes } from '@nodeTypeConfig/helpers/buildingBlocks/proThemeTocTypes';
import { proDocumentStandardComponents } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { proLinksAndMenuReferences } from '@nodeTypeConfig/helpers/editComponents/proLinksAndMenuReferences';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { proTileStandardComponents } from '@nodeTypeConfig/helpers/editComponents/proTileStandardComponents';
import {
  asideWebBasicConfiguration,
  asideWebFacetConfiguration,
} from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { proDefaultBuildingBlocks } from '../../helpers/buildingBlocks/proDefaultBuildingBlocks';
import { extendsSection } from '../../helpers/genericConfigHelpers';

import {
  proThemeDefaultValidationRules,
  proTileDefaultValidionRules,
} from '../proGenericConfigProps';
import { proContactsComponent } from '@nodeTypeConfig/helpers/editComponents/proContactsComponent';

const proDownloadPage = {
  information: {
    definiteArticle: true,
    description:
      'Pro Downloadlijst (webTemplate code DOWNLOAD_PAGE) can be a SECTION (a tile) in a home or can be the root (single page pro theme, although only two standalone download pages in total...)',
    single: 'PRO.-tegel: Downloadlijst',
    plural: 'Downloadlijsten',
    icon: require('../../../../../img/icons/webpage.svg'),
  },
  buildingBlocks: proDefaultBuildingBlocks
    .filter((block) => block.type !== NodeType.ATTACHMENTS_GROUP)
    .concat({ type: NodeType.DOWNLOAD }),
  webTab: [...asideWebBasicConfiguration, ...asideWebFacetConfiguration],
};

// Extends SECTION => A SECTION inside a Pro Theme and WebConfig DOWNLOAD_PAGE becomes a PRO_DOWNLOAD_PAGE_TILE
export const PRO_DOWNLOAD_PAGE_TILE: ExtendedBuildingBlockNodeConfig = {
  ...proDownloadPage,
  nodeSelector: selectTitleNode,
  validationRules: [
    ...proTileDefaultValidionRules,
    validateDownloadListAndFaqPageShouldNotHaveDescription,
  ],
  ...extendsSection,
  isCollapsedByDefault: true,
  edit: [
    ...proTileStandardComponents.filter(
      (comp) => comp.component !== 'subject' && comp.property !== 'description',
    ),
    ...proLinksAndMenuReferences,
  ],
  addAccessRightsToAudienceTab: true,
  confirmDelete: true,
};

// Extends WEBPAGE2 => When adding DOWNLOAD_PAGE WebConfig to a WEBPAGE2 it becomes a PRO_DOWNLOAD_PAGE_STANDALONE
export const PRO_DOWNLOAD_PAGE_STANDALONE: ExtendedRootNodeConfig = {
  ...proDownloadPage,
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: proThemeDefaultValidationRules,
  information: {
    ...proDownloadPage.information,
    single: 'PRO.-thema: Downloadlijst',
  },
  extends: NodeType.WEBPAGE2,
  tocTypes: proThemeTocTypes,
  edit: [
    ...proDocumentStandardComponents.filter((z) => z.component !== proContactsComponent.component),
    ...proLinksAndMenuReferences,
  ],
  audienceTab: proThemeAudienceTab,
  addAccessRightsToAudienceTab: true,
};
